export default function toggleFullscreen() {
  const isInFullscreen = (document.fullscreenElement && document.fullscreenElement !== null)
        || (document.webkitFullscreenElement && document.webkitFullscreenElement !== null)
        || (document.mozFullScreenElement && document.mozFullScreenElement !== null)
        || (document.msFullscreenElement && document.msFullscreenElement !== null);
  const elem = document.getElementById('app');
  if (isInFullscreen) {
    if (document.exitFullscreen) {
      document.exitFullscreen();
    } else if (document.webkitExitFullscreen) { /* Firefox */
      document.webkitExitFullscreen();
    } else if (document.mozCancelFullScreen) { /* Chrome, Safari and Opera */
      document.mozCancelFullScreen();
    } else if (document.msExitFullscreen) { /* IE/Edge */
      document.msExitFullscreen();
    }
    return false;
  }
  if (elem.requestFullscreen) {
    elem.requestFullscreen();
  } else if (elem.mozRequestFullScreen) { /* Firefox */
    elem.mozRequestFullScreen();
  } else if (elem.webkitRequestFullscreen) { /* Chrome, Safari and Opera */
    elem.webkitRequestFullscreen();
  } else if (elem.msRequestFullscreen) { /* IE/Edge */
    elem.msRequestFullscreen();
  }
  return true;
}
